import React from 'react';

import Avatar from 'components/Avatar';

import './styles.css';

const LocationsSection = ({locations}) => (
  <div className="LocationsSection">
    <div className="header">
      <div className="heading">Locations</div>
    </div>
    <div className="content">
      {locations.map(location => (
        <div key={location.ref} className="locationBoxContainer">
          <div className="locationBox">
            <Avatar url={location.thumbnailImage} initials="" />
            <div className="info">
              <div className="name">{location.name}</div>
              <div className="postalCode">{location.address.postalCode}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default LocationsSection;
